import React, { useState } from "react";
import {
  CommonGrid2,
  DataFound,
} from "../../../common-components/StyledComponents";
import { Typography } from "@mui/material";
import { CustomizeSpan } from "../../style";
import CommonButton from "../../../../component/Button";
import HaileyStartIco from "../../../../assets/icons/HaileyStartIco";
import HoverHaileyIco from "../../../../assets/icons/HoverHaileyIco";
import GoToJobIco from "../../../../assets/icons/GoToJobIco";
import { CustomDiv } from "../../../chat-bot/style";
import { HandleSkeletion } from "../../../../utils/constants";

export default function JobReDiscovery({
  checkWidth,
  data,
  handleGoToJob,
  isLoading,
  type = "jobs",
}) {
  const [hovered, setHovered] = useState(null);

  return (
    <CommonGrid2 container spacing={2}>
      {isLoading ? (
        <HandleSkeletion height={100} width={"100%"} />
      ) : data.length === 0 ? (
        <DataFound padding="10px" margin="auto">
          <CustomDiv fontSize="20px">👋</CustomDiv>
          {"No results found"}
        </DataFound>
      ) : type === "jobs" ? (
        data.map((item, index) => (
          <CommonGrid2
            background="#F5F6F7"
            padding={"1rem"}
            borderRadius={"10px"}
            item
            size={{
              xs: 12,
              md: checkWidth < 850 ? 6 : 4,
              sm: checkWidth < 650 ? 12 : 6,
            }}
            onMouseLeave={() => setHovered(false)}
          >
            <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"0px"}>
              <Typography variant="body4" fontWeight={600}>
                {item.job_title}
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                <CustomizeSpan color="#7F56D9">
                  {item.client} {" - "}
                </CustomizeSpan>
                {item.order_no}
              </Typography>
            </CommonGrid2>
            <CommonGrid2
              display={"flex"}
              flexWrap={"wrap"}
              gap={"8px"}
              marginTop={"10px"}
            >
              <CommonButton
                value={"Go to Job"}
                borderRadius={"50px"}
                startIcon={<GoToJobIco size="12" />}
                onClick={() => handleGoToJob(item)}
                variant="outlined"
                padding={"0px 10px 0px 14px"}
                gap={"0px"}
                color="#344054"
                fontSize={"14px"}
                svg={true}
              />

              <CommonGrid2
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
              >
                {hovered === index ? (
                  <CommonButton
                    value={"Ask Hailey about Job"}
                    fontSize={"13px"}
                    padding={"2px 10px 2px 1rem"}
                    gap={"0px"}
                    startIcon={<HaileyStartIco />}
                    borderRadius="50px"
                    onClick={() => handleGoToJob(item, true)}
                  />
                ) : (
                  <HoverHaileyIco />
                )}
              </CommonGrid2>
            </CommonGrid2>
          </CommonGrid2>
        ))
      ) : (
        data.map((item, index) => (
          <CommonGrid2
            background="#F5F6F7"
            padding={"1rem"}
            borderRadius={"10px"}
            item
            size={{
              xs: 12,
              md: checkWidth < 850 ? 6 : 4,
              sm: checkWidth < 650 ? 12 : 6,
            }}
            onMouseLeave={() => setHovered(false)}
          >
            <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"0px"}>
              <Typography variant="body4" fontWeight={600}>
                {item.job_title}
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                <CustomizeSpan color="#7F56D9">
                  {item.client} {" - "}
                </CustomizeSpan>
                {item.req_id}
              </Typography>
            </CommonGrid2>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
              marginTop={"8px"}
            >
              <CommonButton
                value={"Go to Job"}
                borderRadius={"50px !important"}
                startIcon={<GoToJobIco size="12" />}
                onClick={() => handleGoToJob(item)}
                variant="outlined"
                padding={"0px 10px 0px 14px"}
                gap={"0px"}
                color="#344054"
                fontSize={"14px"}
                svg={true}
              />

              <Typography
                variant="body8"
                marginTop={"10px"}
                border={
                  item.status === "Do Not Hire"
                    ? "1px solid #ff0700"
                    : item.status === "Active"
                    ? "1px solid #AAEFC6"
                    : item.status === "Inactive"
                    ? "1px solid rgb(174, 170, 239)"
                    : "1px solid #ffa000"
                }
                backgroundColor={
                  item.status === "Do Not Hire"
                    ? "#ff070026"
                    : item.status === "Active"
                    ? item.status === "Inactive"
                      ? "rgba(79, 70, 255, 0.47)"
                      : "#ECFDF3"
                    : "#ffa6021c"
                }
                color={
                  item.status === "Do Not Hire"
                    ? "#ff0700"
                    : item.status === "Active"
                    ? "#067647"
                    : item.status === "Inactive"
                    ? "rgb(79, 70, 255)"
                    : "#ff9000"
                }
                padding={"2px 10px"}
                borderRadius={"5px"}
                fontWeight={600}
              >
                {item.status}
              </Typography>
            </CommonGrid2>
          </CommonGrid2>
        ))
      )}
    </CommonGrid2>
  );
}
